// extracted by mini-css-extract-plugin
export default {"wrapper":"mo-z","response":"no-z","error":"oo-z","disabled":"po-z","buttons":"qo-z","feedbackQuestionSection":"ro-z","yesNoWrapper":"so-z"};